import { CommonModule } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { NzSelectModule } from "ng-zorro-antd/select";
import { RestService } from "../../../core/services/rest.service";
import { MaterialModule } from "../../../core/shared/material.module";
import { DropdownWithSectionsComponent } from "../../common/dropdown-with-sections/dropdown-with-sections.component";
import { LoadingComponent } from "../../common/loading/loading.component";

@Component({
  selector: "app-configure-asset-llm-modal",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    DropdownWithSectionsComponent,
    NzSelectModule,
    LoadingComponent,
  ],
  templateUrl: "./configure-asset-llm-modal.component.html",
  styleUrl: "./configure-asset-llm-modal.component.scss",
})
export class ConfigureAssetLlmModalComponent {
  activeModal = inject(NgbActiveModal);

  @Input()
  connections: any[] = [];

  @Input()
  projectId: any = [];

  @Input()
  label: string = "";

  @Input()
  type: string = "";
  isActive: boolean = false;

  isGlobal: string = "true";
  showAssets = false;
  globalConnection: any = "";
  assets: any = [];
  options: any = [];
  dropdownConfig: any = {
    placeholderText: "Select connection",
    placeholderIcon: "",
    iconType: "assetImage",
  };
  isLoading = false;

  constructor(private readonly restService: RestService) {}

  ngOnInit() {
    if (this.connections?.length) this.groupConnections();
    this.loadConfigurableAssets();
  }

  groupConnections() {
    // find unique group names
    let groups: any = [];
    this.connections.forEach((ele: any) => {
      if (ele?.meta?.displayName && !groups.includes(ele.meta.displayName)) {
        groups.push(ele.meta.displayName);
      }
    });

    // Group options
    groups.forEach((groupName: any) => {
      let obj = {
        label: groupName,
        type: groupName,
        options: this.connections
          .filter((conn: any) => conn?.meta?.displayName === groupName)
          .map((ele: any) => {
            return {
              label: ele.connectionName,
              value: ele.id,
              icon: "assets/images/virtusa-icons/connection-icon.png",
            };
          }),
      };
      this.options.push(obj);
    });

    // Ungrouped connections
    let ungrouped = this.connections.filter(
      (ele: any) => !ele?.meta || !ele?.meta?.displayName
    );
    if (ungrouped.length) {
      let obj = {
        label: "Ungrouped",
        type: "ungrouped",
        options: ungrouped.map((ele: any) => {
          return {
            label: ele.connectionName,
            value: ele.id,
            icon: "assets/images/virtusa-icons/connection-icon.png",
          };
        }),
      };
      this.options.push(obj);
    }
  }

  loadConfigurableAssets() {
    this.isLoading = true;
    if (this.type === "LLM") {
      this.restService.getLLMConfs(this.projectId).subscribe(
        (response: any) => {
          this.isLoading = false;
          this.isGlobal = response?.data?.isCommonLLM ? "true" : "false";
          if (!response?.data?.isCommonLLM) this.showAssets = true;
          this.globalConnection = response?.data?.globalLLm
            ? response.data.globalLLm
            : "";
          if (response?.data?.applicationLLMs) {
            Object.keys(response?.data?.applicationLLMs).forEach(
              (key: string) => {
                let obj = {
                  key,
                  ...response?.data?.applicationLLMs[key],
                };
                this.assets.push(obj);
              }
            );
          }
        },
        (error) => {
          this.isLoading = false;
        }
      );
    } else if (this.type === "LLM_PARSER") {
      this.restService.getLLaMaConfs(this.projectId).subscribe(
        (response: any) => {
          this.isLoading = false;
          this.isGlobal = response?.data?.isCommonLLMParser ? "true" : "false";
          if (!response?.data?.isCommonLLMParser) this.showAssets = true;
          this.globalConnection = response?.data?.globalLLmParser
            ? response.data.globalLLmParser
            : "";
          if (response?.data?.applicationLLMParserConnections) {
            Object.keys(
              response?.data?.applicationLLMParserConnections
            ).forEach((key: string) => {
              let obj = {
                key,
                ...response?.data?.applicationLLMParserConnections[key],
              };
              this.assets.push(obj);
            });
          }
        },
        (error) => {
          this.isLoading = false;
        }
      );
    }
  }

  displayAssets(forceTrue?: boolean) {
    if (forceTrue) {
      this.showAssets = true;
      return;
    }
    this.showAssets = !this.showAssets;
  }

  save() {
    // let selectedAssets: any = [];
    let selectedAssets = this.assets.filter((asset: any) => asset.llmId);
    let obj: any = {};
    selectedAssets.forEach((ele: any) => {
      obj[ele.key] = ele.llmId;
    });
    this.activeModal.close({
      isGlobal: this.isGlobal === "true",
      globalConnection: this.globalConnection,
      assets: obj,
    });
  }

  onChange() {
    this.showAssets = false;
  }

  getNames(name: string) {
    switch (name) {
      case 'llm connections':
        return 'LLM connections';
      default:
        return name;
    }
  }

  get canSave(): boolean {
    if (this.isGlobal === 'true') {
      return !!this.globalConnection;
    }
    return this.assets.length > 0 && this.assets.every((asset: any) => !!asset.llmId);
  }
}
